/** Plain-text file the user can store in a password manager: each code works once. */
export function backupCodesText(codes: string[], email: string, now = new Date()): string {
  return [
    'Mandistry backup codes',
    email ? `Account: ${email}` : '',
    `Created: ${now.toISOString().slice(0, 10)}`,
    '',
    'Each code can be used once to sign in when you cannot use your authenticator app.',
    'Keep this file somewhere safe (for example in your password manager) and do not share it.',
    '',
    ...codes,
    '',
  ]
    .filter((l, i, a) => l !== '' || a[i - 1] !== '')
    .join('\n');
}

export function downloadBackupCodes(codes: string[], email: string): void {
  const url = URL.createObjectURL(
    new Blob([backupCodesText(codes, email)], { type: 'text/plain;charset=utf-8' }),
  );
  const a = Object.assign(document.createElement('a'), { href: url, download: 'mandistry-backup-codes.txt' });
  a.click();
  URL.revokeObjectURL(url);
}
